import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function BodyStyleChips() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="chips"
      name="bodyStyle"
      isDeselectable
      options={catalogueApi?.vehicleStyleOptions ?? []}
      label={i18n.t('entity.vehicle.labels.body')}
    />
  );
}
